<script setup>
defineProps({
  block: {
    type: Boolean,
  },
  color: {
    type: String,
  },
  disabled: {
    type: Boolean,
  },
  elevation: {
    type: [Number, String],
  },
  exact: {
    type: Boolean,
  },
  loading: {
    type: [Boolean, String],
  },
  rounded: { type: [Boolean, Number, String] },
  size: {
    type: [Number, String],
  },
  text: {
    type: String,
  },
  to: {},
  variant: {
    type: String,
  },
})
</script>

<template>
  <v-btn
    :block="block"
    :color="color"
    :disabled="disabled"
    :elevation="elevation"
    :exact="exact"
    :loading="loading"
    :variant="variant"
    :rounded="rounded"
    :size="size"
    :text="text"
    :to="to"
  >
    <slot />
  </v-btn>
</template>
